/** Legacy strings for ادارة البرامج التدريبية — Resources + Admin/ProgramsManagement. */
export const strings = {
  /** مرفقات الدورة — `_ProgramManagement_Attachments_Modal`. */
  attachments: {
    title: 'مرفقات الدورة التدريبية', // CoursesManagement.Attachments
    add: 'مرفق جديد',
    count: (n) => (n === 0 ? 'لا توجد مرفقات' : `${n} مرفق`),
    nameAr: 'الاسم بالعربية',
    nameEn: 'الاسم بالإنجليزية',
    fileAr: 'الملف بالعربية',
    fileEn: 'الملف بالإنجليزية',
    /* Only on an edit: an empty file field there means "leave it as it is", which is not
       what an empty file field usually means. */
    keepExisting: 'اتركه فارغا للإبقاء على الملف الحالي',
    noFiles: 'لا توجد ملفات',
    nameRequired: 'الاسم بالعربية والإنجليزية مطلوبان',
    filesRequired: 'يجب إرفاق الملف بالعربية والإنجليزية عند الإضافة',
    edit: 'تعديل',
    remove: 'حذف',
    removeConfirm: (name) => `سيتم حذف المرفق "${name}" وملفاته. لا يمكن التراجع عن هذه العملية.`,
    save: 'حفظ',
    saving: 'فضلا انتظر',
    empty: 'لا توجد مرفقات لهذه الدورة',
    emptyHint: 'يمكن إضافة ملفات يطلع عليها المتدرب مع محتوى الدورة.',
  },

  /** استثناءات المتدربين — `_ProgramManagement_Exceptions_Modal` and its "تعديل الإستثناءات". */
  exceptions: {
    title: 'قائمة الإستثناءات', // Exceptions List
    hint: 'محاولات اختبار إضافية أو مدة أطول، لمتدربين بأعينهم في هذه الدورة',
    add: 'استثناء جديد',
    type: 'نوع الإستثناء', // Exception Type
    types: {
      tries: 'محاولات إضافية',
      until: 'تمديد المدة',
      both: 'الاثنان معا',
    },
    columns: {
      index: '#',
      user: 'المتدرب',
      department: 'الإدارة',
      tries: 'عدد محاولات الإختبار', // Number Of Tries
      until: 'يمكنه حضور الدورة حتى', // Can Attend Until
    },
    triesHint: 'العدد الكلي المسموح به لهذا المتدرب، وليس عددا يضاف إلى محاولات الدورة',
    untilHint: 'آخر يوم يستطيع فيه المتدرب دخول الدورة',
    findUser: 'ابحث عن متدرب',
    findUserHint: 'بالاسم أو اسم المستخدم أو البريد الإلكتروني',
    search: 'بحث',
    searching: 'فضلا انتظر',
    chosen: (n) => (n === 1 ? 'تم اختيار متدرب واحد' : `تم اختيار ${n} متدرب`),
    /* The fallback when the users list refuses the request — see UserPicker. */
    usernames: 'أسماء المستخدمين',
    usernamesHint: 'اكتب اسم المستخدم، وافصل بين الأسماء بفاصلة',
    usersRequired: 'اختر متدربا واحدا على الأقل',
    triesRequired: 'أدخل عدد المحاولات',
    triesRange: 'عدد المحاولات يجب أن يكون بين 1 و 100',
    untilPast: 'تاريخ نهاية المدة يجب ألا يكون في الماضي',
    untilRequired: 'اختر تاريخ نهاية المدة',
    edit: 'تعديل',
    remove: 'حذف',
    removeConfirm: (name) => `سيتم حذف استثناء "${name}" من هذه الدورة.`,
    save: 'حفظ',
    saving: 'فضلا انتظر',
    empty: 'لا توجد استثناءات في هذه الدورة',
  },

  actionFailed: 'تعذر إتمام العملية',
  /* Each names the call that failed; the server answers them all with the same line. */
  fail: {
    list: 'تعذر تحميل البرامج التدريبية',
    detail: 'تعذر تحميل بيانات البرنامج التدريبي',
    save: 'تعذر حفظ البرنامج التدريبي',
    copy: 'تعذر نسخ البرنامج التدريبي',
    activate: 'تعذر تفعيل البرنامج التدريبي',
    disable: 'تعذر تعطيل البرنامج التدريبي',
    order: 'تعذر حفظ ترتيب البرامج التدريبية',
    groups: 'تعذر حفظ إدارات البرنامج',
    certificate: 'تعذر حفظ شهادة البرنامج',
    saveCourse: 'تعذر حفظ الدورة التدريبية',
    deleteCourse: 'تعذر حذف الدورة التدريبية',
    exam: 'تعذر تحميل إعدادات اختبار الدورة',
    saveExam: 'تعذر حفظ اختبار الدورة',
    notification: 'تعذر حفظ إشعار الدورة',
    attachment: 'تعذر إتمام العملية على مرفقات الدورة',
    exception: 'تعذر إتمام العملية على استثناءات الدورة',
  },
  title: 'ادارة البرامج التدريبية', // Resources.LearningProgramsManagement
  searchLabel: 'ابحث في البرامج التدريبية بالاسم',

  /* This slice answers in English whatever the panel's language is — see the note on
     `SERVER_MESSAGES` in programsService.js. These are what its ten sentences say here. */
  messages: {
    saved: 'تمت العملية بنجاح', // Resources.Operation_Completed_Successfully
    programSaved: 'تم حفظ البرنامج التدريبي بنجاح',
    programCopied: 'تم نسخ البرنامج التدريبي بنجاح',
    programActivated: 'تم تفعيل البرنامج التدريبي',
    programDisabled: 'تم تعطيل البرنامج التدريبي',
    groupsSaved: 'تم حفظ إدارات البرنامج بنجاح',
    certificateSaved: 'تم حفظ شهادة البرنامج بنجاح',
    notificationSaved: 'تم حفظ إشعار الدورة بنجاح',
    programNotFound: 'البرنامج التدريبي غير موجود',
    courseNotFound: 'الدورة التدريبية غير موجودة في هذا البرنامج',
    attachmentNotFound: 'المرفق غير موجود',
    nameTaken: 'اسم البرنامج التدريبي مستخدم مسبقا',
    invalidInput: 'البيانات المدخلة غير صحيحة',
    requestFailed: 'حدث خطأ أثناء تنفيذ الطلب',
  },

  actions: {
    create: 'برنامج تدريبي جديد', // ProgramsManagement.btnNew
    quickCreate: 'إنشاء سريع', // ProgramsManagement.BtnQuickNew
    ordering: 'ترتيب البرامج التدريبية', // Resources.LearningProgramOrdering
  },

  /** The course notification dialog — `_ProgramManagement_Mail_Modal.cshtml`. */
  notify: {
    title: 'إرسال تنبيه', // CoursesManagement.LocNotifications
    event: 'التنبيه',
    onStart: 'عند بداية الدورة', // CoursesManagement.LocStartCourse
    onEnd: 'عند نهاية الدورة', // CoursesManagement.LocEndCourse
    when: 'وقت الإرسال',
    inMinutes: 'بعد دقائق',
    inDays: 'بعد أيام',
    onDate: 'في تاريخ محدد',
    minutes: 'عدد الدقائق',
    days: 'عدد الأيام', // CoursesManagement.LocStartDays
    date: 'تاريخ الإرسال', // CoursesManagement.LocStartDate
    delay: 'التأخير بين الرسائل', // CoursesManagement.SendDelay
    delayHint: 'بالثواني، لتفادي رفض الخادم عند إرسال عدد كبير من الرسائل',
    whenRequired: 'فضلا حدد وقت الإرسال',
    note: 'يتم إرسال التنبيه لجميع المتدربين المسجلين في البرنامج التدريبي',
    send: 'إرسال', // Resources.Send
    sending: 'فضلا انتظر',
  },

  /** The ordering dialog — `_ProgramManagement_Ordering_Modal.cshtml`. */
  ordering: {
    title: 'ترتيب البرامج التدريبية', // Resources.LearningProgramOrdering
    hint: 'الترتيب الذي تظهر به البرامج للمتدربين',
    moveUp: 'تحريك لأعلى',
    moveDown: 'تحريك لأسفل',
    save: 'حفظ الترتيب', // Resources.Save
    saving: 'فضلا انتظر',
  },

  /** The four dials, shared with the dashboard. */
  shares: {
    success: 'نسبة النجاح', // LearningProgramsReports.LocSuccessPercentage
    failure: 'نسبة الرسوب',
    incomplete: 'نسبة عدم الاكتمال',
    incompleteNote: '(حضر اختبار واحد على الأقل و لم يكمل باقي الاختبارات)',
    absent: 'نسبة عدم الحضور',
    absentNote: '(من لم يحضر أي اختبار)',
  },

  columns: {
    name: 'الإسم', // Resources.Name
    groups: 'الإدارات', // Resources.Groups
    courses: 'الدورات التدريبية', // Courses.PageResource1.Title
    startDate: 'تاريخ البداية', // Resources.StartDate
    endDate: 'تاريخ النهاية', // Resources.EndDate
    status: 'الحالة', // Resources.Status
  },

  row: {
    notify: 'إرسال تنبيه', // CoursesManagement.LocNotifications
    notifyDisabled:
      'ارسال التنبيه غير نشط، بالإمكان تفعيل الخاصية من صفحة إعدادات عامة تبويب إعدادات التنبيهات', // WorkspacePoliciesSettings.btnSendEmailDisabled
    edit: 'تعديل', // CoursesManagement.btnEdit
    report: 'التقرير', // Resources.Report
    clone: 'نسخ', // ProgramsManagement.Clone
    delete: 'حذف', // ProgramsManagement.btnDelete
    /* Added on the legacy `develop` branch ("Migrating Similar Courses Results",
       de3c417). The view writes these inline rather than through a resx. */
    migrate: 'نقل النتائج السابقة',
  },

  /**
   * برنامج تدريبي جديد / تعديل — _ProgramManagement_Program_Modal.cshtml.
   * Every label is the legacy modal's; `identity` and `visibility` are section
   * headings, which the legacy has none of.
   */
  /**
   * دورة تدريبية — Views/ProgramsManagement/_ProgramManagement_Courses_Modal.
   *
   * The last of the legacy's five wizards. Where a label has no resx pair, the
   * legacy's resource KEY is the English sentence itself (`Has_Exam`,
   * `Forced_to_watch_content_before_the_test`) and the Arabic is written here to
   * match it.
   */
  course: {
    title: 'دورة تدريبية جديدة', // CoursesManagement.btnNew
    editTitle: 'تعديل الدورة التدريبية',
    steps: {
      info: 'معلومات الدورة', // CoursesManagement.CourseInfoTitle
      topics: 'المواضيع', // CoursesManagement.CategoriesTitleResource1_Text
      exam: 'خيارات الاختبار', // ManageExams.LocExamOptionPanelTitle
    },
    level: 'المستوى', // CoursesManagement.levels
    startDate: 'تاريخ البداية', // CoursesManagement.StartDateTextBoxLabelResource1_Text
    endDate: 'تاريخ نهاية', // CoursesManagement.EndDateTextBoxLabelResource1_Text
    contentType: 'نوع المحتوى', // Resources.Content_Type
    hasExam: 'هل تحتوي على اختبار', // Resources.Has_Exam
    banner: 'رفع صورة', // CoursesManagement.CourseBannerUpload
    scorm: 'ملف حزمة السكورم', // Resources.Scorm_Package_File
    videoTopic: 'موضوع فيديو',
    scormQuestionBank: 'أسئلة اختبار SCORM',
    questionBank: 'بنك أسئلة',
    rawamExam: 'اختبار روام منفصل',
    rawamExamHint: 'اطلب اختبارًا من روام بعد إكمال هذه الدورة، بالإضافة إلى أي اختبار داخل حزمة SCORM.',
    scormHint: 'ملف ZIP بصيغة SCORM 1.2 يحتوي على كائن تعليمي واحد. اترك الحقل فارغًا فقط إذا كانت حزمة هذه اللغة مثبتة بالفعل.',
    scormExamTopics: 'اختر موضوعات الأسئلة لاختبار روام المنفصل. محتوى الدورة موجود داخل ملف ZIP.',
    scormZipRequired: 'اختر ملف ZIP لحزمة SCORM.',
    scormTooLarge: 'يجب ألا يتجاوز حجم حزمة SCORM مئة ميغابايت.',
    scormEmpty: 'ملف حزمة SCORM فارغ.',
    scormInstalled: 'تبقى الحزم المثبتة عند ترك حقولها فارغة. يجب تثبيت حزمتي اللغتين قبل الحفظ.',
    scormArabic: 'حزمة SCORM العربية (ZIP)',
    scormEnglish: 'حزمة SCORM الإنجليزية (ZIP)',
    scormExistingLanguage: 'لغة الحزمة الحالية',
    scormChooseLanguage: 'اختر لغة الحزمة الحالية',
    contentTypeLocked: 'لا يمكن تغيير نوع المحتوى بعد إنشاء الدورة.',
    file: 'الملف',
    yes: 'نعم', // Resources.Yes
    no: 'لا', // Resources.No
    passLimit: 'نسبة النجاح', // ManageExams.LocPassLimit
    examTries: 'عدد مرات دخول الاختبار', // ManageExams.LocExamTries
    questionsCount: 'عدد الأسئلة', // ManageExams.LocQuestionsCount
    rewatchPercentage: 'نسبة إجبار المستخدم على إعادة مشاهدة المحتوى',
    rewatchHint:
      'في حال أردت تفعيل إجبار المستخدم على إعادة مشاهدة المحتوى عند الرسوب، ضع قيمة بين ١ ونسبة أقل من درجة النجاح.', // Resources.In_the_event_that_you_want_to_activate…
    forceWatch: 'إجبار مشاهدة المحتوى قبل الاختبار',
    hideAnswers: 'إخفاء الإجابات الصحيحة عند الرسوب',
    preventIfSuccess: 'منع إعادة دخول الاختبار عند النجاح',
    quizEnable: 'تفعيل الاختبار القصير بعد مشاهدة الموضوع',
    topicsRequired: 'اختر موضوعا واحدا على الأقل',
    topicsNote:
      'أثناء تحديث الدورة التدريبية عند إضافة مواضيع أو إزالتها، يتعين عليك تحديث قواعد أسئلة الاختبار بنفسك وفقا لذلك', // Resources.While_Updating_Course…
    searchTopics: 'ابحث في المواضيع',
    publicity: 'التخصيص', // CategoriesManagement.Publicity
    publicityAll: 'الكل',
    public: 'عام', // CategoriesManagement.Public
    private: 'خاص', // CategoriesManagement.Private
    order: 'ترتيب المواضيع',
    orderHint: 'الترتيب هو تسلسل المواضيع داخل الدورة', // Resources.OrderingTootltip, as arrows rather than a drag handle
    orderEmpty: 'لم يختر أي موضوع بعد',
    moveUp: 'تقديم',
    moveDown: 'تأخير',
  },

  form: {
    quickTopicsOnly: 'الإنشاء السريع ينشئ دورات من المواضيع واختبارات روام. لرفع حزمة SCORM، أنشئ البرنامج أولاً، ثم أضف دورة من نوع SCORM.',
    editTitle: 'تعديل البرنامج التدريبي', // LearningProgramInfoTitle
    identity: 'اسم البرنامج ووصفه',
    visibility: 'ظهور الدورات',
    arabicName: 'الاسم بالعربية', // ArabicNameLabelResource1_Text
    englishName: 'الاسم بالإنجليزية', // EnglishNameLabelResource1_Text
    arabicDescription: 'الوصف بالعربية', // ArabicDescriptionLabelResource1_Text
    englishDescription: 'الوصف بالإنجليزية', // EnglishDescriptionLabelResource1_Text
    pastCourses: 'الدورات المنتهية', // Resources.Finished_Courses__Courses_with_past_end_date_
    futureCourses: 'الدورات القادمة', // Resources.Future_Courses
    pastViews: {
      show: 'إظهار', // Resources.Show
      hide: 'إخفاء', // Resources.Hide
      disabled: 'معطلة', // Resources.Disabled
      showButNoExam: 'إظهار مع تعطيل الاختبار', // Resources.View_but_exam_disabled
    },
    futureViews: {
      show: 'إظهار',
      hide: 'إخفاء',
      disabled: 'إظهار معطلة حتى موعد البداية',
      showButNoExam: 'إظهار مع تعطيل الاختبار',
      allowIfWatchedPrevious: 'إتاحتها بعد مشاهدة ما قبلها', // Resources.allowIfWatchedPrevious
    },
    allowLateCourses:
      'السماح بإضافة دورة تدريبية جديدة للبرنامج بعد نجاح أو رسوب بعض المستخدمين', // Resources.Allowing_a_new_training_course_...
    allowLateCoursesNote:
      'المستخدمون الذين أنهوا البرنامج بالفعل لن تتأثر حالة نجاحهم', // Resources.Notice_that_if_you_allow_adding_courses_...
    /* The three steps the legacy's own quick wizard uses, and the two the full
       form is split into. */
    steps: {
      identity: 'بيانات البرنامج', // labelQuickProgramStep1
      visibility: 'ظهور الدورات',
      topics: 'اختيار المواضيع', // labelQuickProgramStep2
      options: 'تحديد الخيارات', // labelQuickProgramStep3
    },
    topics: 'المواضيع المتاحة', // LabelTopics
    topicsHint: 'المواضيع المراد تحويلها إلى دورة تدريبية. تظهر هنا المواضيع التي لها أسئلة اختبار فقط', // LabelTopicsHint
    topicsRequired: 'اختر موضوعا واحدا على الأقل',
    topicsChosen: 'موضوعا مختارا',
    coursesMade: (made, total) => `تم إنشاء ${made} من ${total} دورة`,
    selectAll: 'تحديد الكل', // Resources.SelectAll
    clearAll: 'إلغاء التحديد',
    courseOptions: 'خيارات الدورات', // LabelCoursesOptions
    passLimit: 'نسبة النجاح', // ManageExams.LocPassLimit
    questionsCount: 'عدد الأسئلة', // ManageExams.LocQuestionsCount
    startDate: 'تاريخ البداية', // CoursesManagement.StartDateTextBoxLabelResource1_Text
    endDate: 'تاريخ نهاية', // CoursesManagement.EndDateTextBoxLabelResource1_Text
    range: 'القيمة خارج المدى المسموح',
    dateOrder: 'تاريخ النهاية يجب أن يلي تاريخ البداية',
    quickTitle: 'إنشاء سريع', // the page's own action label
    quickSubtitle: 'برنامج ودورات واختبارات في ثلاث خطوات',
    save: 'حفظ', // Resources.Save
    close: 'إغلاق', // Users.btnClose
    required: 'الحقل مطلوب',
    nameLetters: 'الاسم يجب أن يحتوي على حروف، ولا يكتفي بالرموز أو الأرقام',
    nameTaken: 'هذا الاسم مستخدم لبرنامج تدريبي آخر',
    tooLong: (max) => `يجب ألا يتجاوز ${max} حرف`,
    saved: 'تمت العملية بنجاح', // Operation_Completed_Successfully
  },

  migrate: {
    confirm: 'هل أنت متأكد من ترحيل نتائج الدورات لهذا البرنامج؟ قد تستغرق هذه العملية عدة دقائق.',
    migratedCount: 'عدد المستخدمين الذين تم ترحيلهم: ',
    failed: 'حدث خطأ أثناء العملية',
  },

  /**
   * The legacy status cell is a bare icon — a green check-circle or a red
   * times-circle, with no caption. The icons differ in shape, so meaning does not
   * rest on colour; these strings are the accessible names only.
   */
  status: {
    active: 'نشط', // Resources.ACTIVEE
    inactive: 'غير نشط', // Resources.InActive — paired with 'نشط', as the detail page and the server say it
    expired: 'منتهي', // the end date has passed; shown next to the switch chip, never instead of it
  },

  /** The programme detail screen — Views/ProgramsManagement/Index.cshtml. */
  detail: {
    title: 'تعديل البرنامج التدريبي', // Resources.UpdateLearningProgram
    back: 'رجوع', // Resources.Back
    /* The general error heading, the same resource the user-details screen
       already shows in this position. */
    errorHeading: 'رسالة الخطأ', // General.ErrorMessageLabel
    edit: 'تعديل', // ProgramsManagement.btnEdit
    forceRetake: 'إجبار مستخدمين لإعاده البرنامج', // ForceUsersToRetakeProgram
    clone: 'نسخ', // ProgramsManagement.Clone
    active: 'نشط', // Resources.ACTIVEE

    cards: {
      groups: 'الإدارات', // Resources.Departments
      survey: 'الاستبيان', // Resources.Survey
      certificate: 'الشهادة', // Resources.Certificate
    },

    /* The three cards are now the way in, not just a state. */
    setUp: 'إعداد',
    groupsPanel: {
      title: 'إدارات البرنامج',
      legend: 'الإدارات المسندة',
      selectAll: 'تحديد الكل',
      filter: 'بحث عن إدارة',
      assignNew: 'إسناد الإدارات الجديدة تلقائيا',
      noneChosen: 'اختر إدارة واحدة على الأقل',
      assignNewHint: 'أي إدارة تضاف لاحقا من الربط الآلي تسند لهذا البرنامج',
    },
    certificatePanel: {
      title: 'شهادة البرنامج',
      certificate: 'نموذج الشهادة',
      certificateHint: 'النموذج الذي تطبع عليه شهادة هذا البرنامج',
      certificateRequired: 'اختر نموذج الشهادة',
      printLanguage: 'لغة الطباعة',
      languages: { arabic: 'العربية', english: 'الإنجليزية', ui: 'لغة الواجهة' },
      userPrint: 'السماح للمتدرب بطباعة الشهادة',
      emailSend: 'إرسال الشهادة بالبريد',
      personalEmail: 'الإرسال إلى البريد الشخصي',
      departmentName: 'إظهار اسم الإدارة',
      grade: 'إظهار التقدير',
      gradeA: 'حد تقدير ممتاز',
      gradeB: 'حد تقدير جيد جدا',
      gradeC: 'حد تقدير جيد',
      gradeOrder: 'يجب أن يكون حد ممتاز أعلى من جيد جدا، وجيد جدا أعلى من جيد',
      dateConfig: 'تاريخ انتهاء البرنامج',
      dateConfigs: {
        lastCourse: 'آخر دورة',
        lastExam: 'آخر اختبار',
        programEndLastCourse: 'تاريخ نهاية البرنامج أو آخر دورة',
        programEndLastExam: 'تاريخ نهاية البرنامج أو آخر اختبار',
      },
      dateFormat: 'صيغة التاريخ',
      dateFormats: { gregorian: 'ميلادي', hijri: 'هجري', both: 'الاثنان', ui: 'حسب لغة الواجهة' },
      validityType: 'صلاحية الشهادة',
      validity: {
        never: 'لا تنتهي',
        days: 'بالأيام',
        months: 'بالأشهر',
        years: 'بالسنوات',
        period: 'مدة الصلاحية',
        positive: 'أدخل مدة صلاحية أكبر من صفر',
        visibility: 'ظهور الصلاحية',
        adminsAndUsers: 'المشرفون والمتدربون',
        adminsOnly: 'المشرفون فقط',
        usersOnly: 'المتدربون فقط',
      },
    },
    surveyPanel: {
      title: 'استبيان البرنامج',
      steps: { info: 'بيانات الاستبيان', properties: 'خصائص الاستبيان', questions: 'أسئلة الاستبيان' },
      next: 'التالي',
      loading: 'جار التحميل…',
      nameAr: 'الاسم بالعربية',
      nameEn: 'الاسم بالإنجليزية',
      descriptionAr: 'الوصف بالعربية',
      descriptionEn: 'الوصف بالإنجليزية',
      targetNote: 'هذا الاستبيان خاص بهذا البرنامج التدريبي.',
      enabled: 'تفعيل الاستبيان',
      enabledHint: 'لن يظهر الاستبيان للمتدربين قبل تفعيله وإضافة أسئلة له',
      mandatory: 'استبيان إلزامي',
      timeRestricted: 'تحديد مدة الاستبيان',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      groups: 'الإدارات المستهدفة',
      selectAll: 'تحديد الكل',
      filter: 'بحث عن إدارة',
    },

    coursesTitle: ' الدورات في البرنامج التدريبي', // CoursesTitleResource1.Text
    newCourse: 'دورة تدريبية جديدة', // CoursesManagement.btnNew
    importScorm: 'استيراد حزمة SCORM',
    scormImportHint: 'استيراد ملف ZIP يتضمن محتوى اللغتين والأسئلة وصورة الغلاف.',
    scormImportInactive: 'أوقف تفعيل البرنامج قبل استيراد دورة SCORM.',
    scormImportInvalid: 'اختر حزمة SCORM بصيغة ZIP لا تتجاوز 201 ميغابايت.',
    scormImportSuccess: 'تم استيراد دورة SCORM. راجعها قبل تفعيل البرنامج.',
    scormImportFailed: 'تعذّر استيراد دورة SCORM.',
    scormExportFailed: 'تعذّر تصدير دورة SCORM.',

    columns: {
      index: 'م', // CoursesManagement.TableHead_1
      course: 'الدورة', // General.LearningProgramGroupsLevelReport.CourseName
      content: 'المحتوى', // Resources.Content
      exam: 'امتحان', // Resources.Exam
      startDate: 'تاريخ البداية', // CoursesManagement.TableHead_6
      endDate: 'تاريخ النهاية', // CoursesManagement.TableHead_7
    },

    courseRow: {
      exportScorm: 'تصدير حزمة SCORM',
      edit: 'تعديل', // CoursesManagement.btnEdit
      notify: 'إرسال تنبيه', // CoursesManagement.LocNotifications
      notifyDisabled:
        'ارسال التنبيه غير نشط، بالإمكان تفعيل الخاصية من صفحة إعدادات عامة تبويب إعدادات التنبيهات',
      delete: 'حذف', // ProgramsManagement.btnDelete
      survey: 'استبيان الدورة التدريبية', // CoursesManagement.BtnNewSurvey
      attachments: 'المرفقات', // CoursesManagement.BtnManageAttachments
      exceptionsList: 'قائمة الإستثناءات', // Resources.Exceptions_List
      setExceptions: 'تعديل الإستثناءات', // Resources.Set_Exceptions
      addExam: 'إضافة اختبار', // ManageExams.UpdatePanelHeader
      editExam: 'تعديل الاختبار', // ManageExams.UpdatePanelHeader
    },

    deleteCourseConfirm: 'سيتم حذف الدورة التدريبية واختبارها ونتائج المتدربين فيها. لا يمكن التراجع عن هذه العملية.',
  },

  /* SHORT, because the dialog has to be read. The legacy's own warning
     (ProgramsManagement.ar.resx `DeleteConfirm1`) is a 30-word sentence that says the same
     thing — a wall of text above a field asking for work is a wall nobody reads. This keeps
     the one fact that decides it: the trainees' results go too, and nothing comes back. */
  deleteConfirm: 'سيحذف البرنامج ودوراته ونتائج المتدربين. لا يمكن التراجع.',
  /* General.ar.resx `DeleteByProgramName`. */
  deleteByName: 'للتأكيد قم بكتابة اسم البرنامج',

  /* The legacy asked before copying (ProgramsManagement.ar.resx `cloneConfirmMessage`).
     Its request for two names is gone — the copy is named for its original, and renamed
     from the edit screen like any other programme. */
  cloneTitle: 'نسخ البرنامج التدريبي',
  cloneConfirm: 'سيؤدي هذا الإجراء إلى نسخ البرنامج المحدد وإنشاء نسخة جديدة منه. هل تريد المتابعة؟',

  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
  close: 'إغلاق', // Users.btnClose
}

/** تقرير البرامج التدريبية — LearningProgramsReports. */
export const reportsStrings = {
  title: 'تقرير البرامج التدريبية',
  subtitle: 'نتائج برنامج تدريبي، ودوراته، وإجابات استبيانه',
  chooseProgram: 'اختر برنامجا لعرض تقريره',
  notFound: 'البرنامج التدريبي غير موجود',
  notFoundHint: 'اختر برنامجا آخر من القائمة',
  reversedRange: 'تاريخ النهاية يجب أن يلي تاريخ البداية',
  actionFailed: 'تعذر إتمام العملية',
  export: 'تصدير التقرير',
  exportSuccess: 'تم تصدير التقرير بنجاح',
  fail: {
    page: 'تعذر تحميل تقارير البرامج التدريبية',
    export: 'تعذر تصدير تقرير البرنامج التدريبي',
  },

  filter: { program: 'البرنامج التدريبي', from: 'من تاريخ', to: 'إلى تاريخ' },

  tabs: {
    info: 'معلومات البرنامج التدريبي',
    courses: 'نتائج الدورات',
    survey: 'نتائج الاستبيان',
    results: 'نتائج البرنامج التدريبي',
    certificates: 'طباعة الشهادات',
  },

  shares: {
    success: 'ناجح',
    failure: 'راسب',
    incomplete: 'لم يكتمل',
    absent: 'لم يحضر',
  },

  people: {
    title: 'المتدربون',
    tabs: { success: 'ناجح', failure: 'راسب', incomplete: 'لم يكتمل', absent: 'لم يحضر', groups: 'الإدارات' },
    index: '#',
    user: 'المتدرب',
    department: 'الإدارة',
    email: 'البريد الإلكتروني',
    examDate: 'تاريخ الاختبار',
    degree: 'الدرجة',
    watched: 'نسبة المشاهدة',
    users: 'المستخدمون',
    search: 'ابحث عن متدرب',
    searchGroups: 'ابحث عن إدارة',
    empty: 'لا توجد بيانات',
  },

  stats: {
    caption: 'ملخص البرنامج',
    courses: 'الدورات',
    groups: 'الإدارات',
    users: 'المستخدمون',
  },

  courses: {
    title: 'الدورات',
    name: 'الدورة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    topics: 'المواضيع',
    success: 'ناجح',
    failure: 'راسب',
    absent: 'لم يحضر',
    empty: 'لا توجد دورات في هذا البرنامج',
  },

  survey: {
    title: 'نتائج الاستبيان',
    question: 'السؤال',
    answer: 'الإجابة',
    count: 'العدد',
    empty: 'لا توجد إجابات للاستبيان',
  },
}
